<template>
  <div class="">
    <Typography as="div" variant="header-6" class="text-center mb-2.5">
      <div v-html="richTextToHtml(item?.header)"/>
    </Typography>
    <div class="flex gap-2.5 flex-col md:flex-row">
      <Button
        v-for="button in item?.buttons"
        :key="button.url"
        :external="button.openInNewTab"
        :variant="isButtonVariant(button.variant) ? button.variant : 'primary'"
        as="NuxtLink"
        class="grow text-caption-bold"
        size="md"
        :to="button.url">
        {{ button.title }}
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ContentStickyBarApiModel } from '@gro-up/api/corporate'
import { useRichTextToHtml } from '@gro-up/ui/composables'
import { Typography, Button } from '@gro-up/ui/primitives'
import  { isButtonVariant } from '@gro-up/ui/types'

defineProps<{
  item?: ContentStickyBarApiModel
}>();

const { richTextToHtml } = useRichTextToHtml()
</script>
